import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.sharing-center.shared-folders.create', {
        url: '/create',
        views: {
            '@company': 'companySharingCenterSharedFoldersCreate'
        }
    });
}


// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-folders/create/create-shared-folder.state.js